module.exports = __webpack_public_path__ + "75eed84cbf7fc00dd0e1039ecc67b480.png";